import { message } from 'antd';
import * as Sentry from '@sentry/react';
import {
  createApiKeyClient,
  createBearerAuthClient,
  setupErrorInterceptor,
  type ProcessedError,
  type ApiErrorContext,
} from '@raporgor/api-client';
import { API_URL, API_KEY } from '../config';

const IS_DEMO = import.meta.env.VITE_DEMO_MODE === 'true';
const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

// Real-firm panels (newton, vb.) → bearer JWT from localStorage. 401 clears
// session and bounces to /login. Demo panels (perakende/toptan/restoran) keep
// the X-Api-Key flow since their auth is build-time API key, not user JWT.
const handleUnauthorized = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.location.href = '/login';
};

export const apiClient = IS_DEMO
  ? createApiKeyClient(API_URL, API_KEY)
  : createBearerAuthClient(API_URL, TOKEN_KEY, handleUnauthorized);

setupErrorInterceptor(apiClient, {
  onError: (error: ProcessedError) => {
    if (error.severity === 'error') {
      message.error(error.message);
    } else if (error.severity === 'warning') {
      message.warning(error.message);
    }
  },
  reportToSentry: (axiosError, context?: ApiErrorContext) => {
    Sentry.captureException(axiosError, {
      extra: context ? { ...context } : undefined,
    });
  },
});
